import apiPaths from '../../api-paths.js';

export default {
    index(crmId) {
        return axios.get(`${ apiPaths.CRM }/${crmId}/recipient-emails`);
    },
    store(crmId, data) {
        return axios.post(`${ apiPaths.CRM }/${crmId}/recipient-emails`, data);
    },
    delete(crmId, id) {
        return axios.delete(`${ apiPaths.CRM }/${crmId}/recipient-emails/${id}`);
    },
};
